/**
 * Possible built-in field types for {@link DirectAnswer.fieldType}.
 *
 * @public
 */
export var BuiltInFieldType;
(function (BuiltInFieldType) {
    BuiltInFieldType["URL"] = "url";
    BuiltInFieldType["ComplexURL"] = "complex_url";
    BuiltInFieldType["IOSAppURL"] = "ios_app_url";
    BuiltInFieldType["AndroidAppURL"] = "android_app_url";
    BuiltInFieldType["FacebookURL"] = "facebook_url";
    BuiltInFieldType["Email"] = "email";
    BuiltInFieldType["InstagramHandle"] = "instagram_handle";
    BuiltInFieldType["TwitterHandle"] = "twitter_handle";
    BuiltInFieldType["Phone"] = "phone";
    BuiltInFieldType["Address"] = "address";
    BuiltInFieldType["Hours"] = "hours";
    BuiltInFieldType["Decimal"] = "decimal";
    BuiltInFieldType["Integer"] = "integer";
    BuiltInFieldType["SingleLineText"] = "single_line_text";
    BuiltInFieldType["RichText"] = "rich_text";
    BuiltInFieldType["MultiLineText"] = "multi_line_text";
    BuiltInFieldType["RichText_v2"] = "rich_text_v2";
    BuiltInFieldType["Html"] = "html";
    BuiltInFieldType["Markdown"] = "markdown";
})(BuiltInFieldType || (BuiltInFieldType = {}));
//# sourceMappingURL=BuiltInFieldType.js.map